<template>
  <div class="index">
    <div class="common_mbx">
      您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link>
    </div>
    <div class="common_wrap">
      <div class="our_list clearfix">
        <div class="our_item">
          <router-link to="/our/aboutUs">
            <div class="our_item_img">
              <i class="icons i1"></i>
            </div>
            <p class="our_text">关于帝景</p>
            <p>ABOUT US</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/our/core">
            <div class="our_item_img">
              <i class="icons i2"></i>
            </div>
            <p class="our_text">核心价值</p>
            <p>CORE VALUE</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/our/news">
            <div class="our_item_img">
              <i class="icons i3"></i>
            </div>
            <p class="our_text">新闻</p>
            <p>NEWS</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/our/cases/15">
            <div class="our_item_img">
              <i class="icons i4"></i>
            </div>
            <p class="our_text">客户案例</p>
            <p>CUSTORME CASE</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/our/brand/11">
            <div class="our_item_img">
              <i class="icons i5"></i>
            </div>
            <p class="our_text">品牌精选</p>
            <p>BRAND SELECTION</p>
          </router-link>
        </div>
        <div class="our_item">
          <router-link to="/our/contact">
            <div class="our_item_img">
              <i class="icons i6"></i>
            </div>
            <p class="our_text">联系我们</p>
            <p>CONTACT US</p>
          </router-link>
        </div>
        <div class="our_item wd">
          <div class="our_item_img">
            <img src="/static/images/wd.png" alt="" class="wd_icon">
            <img src="/static/images/code.jpg" alt="" class="wd_code">
          </div>
          
        </div>
        <div class="our_item tmall">
          <div class="our_item_img">
            <i class="icons i8"></i>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      isX:false
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){
  }
}
</script>

<style scoped>

 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .common_title{
  font-size: 20px;
  color: #383838;
  text-align: center;
  margin-bottom: 50px;
  padding-top: 60px;
 }
 .common_title:before{
  content: '';
  display: inline-block;
  width: 22px;
  height: 1px;
  background-color: #7e7e7e;
  position: relative;
  top: -6px;
  right: 7px;
 }
 .common_title:after{
  content: '';
  display: inline-block;
  width: 22px;
  height: 1px;
  background-color: #7e7e7e;
  position: relative;
  top: -6px;
  left: 7px;
 }
 .our_item{
  width: 290px;
  height: 320px;
  float: left;
  text-align: center;
  margin-right: 13px;
 }
 .our_item:nth-child(4n){
  margin-right: 0;
 }
 .our_item.tmall,.our_item.wd{
  cursor: pointer;
 }
 .our_item.tmall:hover,.our_item.wd:hover{
  border: none;
 }
 .our_item.wd img{
  display: block;
  margin: 0 auto;
 }
 .our_item.wd .wd_icon{
  top: 50%;
  margin-top: 0;
  left: 50%;
  transform: translate(-50%,-50%);
  position: absolute;
 }
 .our_item.wd .wd_icon:hover+img{
  display: block;
 }
 .our_item.wd .wd_code{
  top: 0%;
  margin-top: 0;
  left: 50%;
  transform: translate(-50%,-70%);
  position: absolute;
  display: none;
 }
 .our_item.tmall .our_item_img,.our_item.wd .our_item_img{
  top: 50%;
  margin-top: 0;
  left: 50%;
  transform: translate(-50%,-50%);
 }
 .our_item:hover{
  border: 1px solid #eeeeee;
  border-radius: 4px;
  box-sizing: border-box;
 }
 .our_item p{
  color: #5d5d5d;
  font-size: 14px;
 }
 .our_text{
  margin-bottom: 20px;
 }
 .our_item_img{
  height: 157px;
  margin-top: 30px;
  position: relative;
 }
 .our_item_img i{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
 }
 .icons{
  display: inline-block;
  background-image: url('../../static/images/our_icons.png')
 }
 .i1{
   width: 55px; height: 59px;
   background-position:-259px -61px;
 }
 .i2{
  width: 67px; height: 64px;
  background-position: -172px -61px;
 }
 .i3{
   width: 48px; height: 40px;
   background-position: -172px -145px;
 }
 .i4{
  width: 44px; height: 47px;
  background-position: -334px -61px;
 }
 .i5{
  width: 39px; height: 45px;
    background-position: -10px -237px;
 }
 .i6{
  width: 39px; height: 43px;
    background-position: -69px -237px;
 }
 .i7{
  width: 142px; height: 207px;
    background-position: -10px -10px;
 }
 .i8{
  width: 220px; height: 31px;
    background-position: -172px -10px;
 }
 .our_list{
  margin-bottom: 40px;
 }
</style>


// WEBPACK FOOTER //
// src/components/our.vue